<!--Banner：示范案例顶部banner 2020/9/18 13:56:40 Sunanguang-->
<template>
  <el-carousel class="its-banners" :height="carouselSet.height" :arrow="carouselSet.arrow" :indicator-position="showIndicator">
      <el-carousel-item class="its-banner" v-for="(banner,i) in banners" :key="i">
        <div class="its-background" :style="'background: url('+ getSrc(banner.key) + ')'"></div>
        <div class="its-left">
          <div class="its-main-title">{{banner.mainTitle}}</div>
          <div class="its-sub-title" v-html="banner.subTitle"></div>
        </div>
        <div class="its-video">
          <play-view ref="playViewRef" :item="banner" :videoStyle="banner" @preview-event="previewEvent"  @fullScreen="fullScreenEvent"></play-view>
        </div>
      </el-carousel-item>
    </el-carousel>
</template>
<script>
import PlayView from '../../../components/PlayView'
export default {
  name:'Banner',
  components: {
    PlayView
  },
  props:{
    banners:{ //banner列表
      type:Array,
      default:function(){
        return []
      }
    },
    carouselSet:{
      type:Object,
      default:function(){
        return {
          arrow:'never',//箭头显示
          height: '776px'
        }
      }
    }
  },
  data(){
    return {
      showIndicator:'outside'
    }
  },
  mounted(){
    if(this.banners.length==1){
      this.showIndicator = 'none'
    }
  },
  methods: {
    getSrc: function (key) {
      return require('@/assets/images/case_banner_' + key + '_bg.png')
    },
    previewEvent: function (data) {
      this.$emit('preview-event', data)
    },
    fullScreenEvent: function (isFullScreen) {
      console.log(isFullScreen)
      this.$emit('fullScreen', isFullScreen)
    },
  }
}
</script>
<style scoped>
.its-banners{
  height: auto;
  position: relative;
  z-index: 1;
  font-family: 'MicrosoftYaHei-Bold';
}
.its-background{
  height: 775px;
  width: 100%;
  background-color: red;
  background-repeat: no-repeat !important;
  background-size: cover !important;
}
.its-src {
  width: 611px;
  height: 551px;
  position: absolute;
  bottom: 54px;
  left: 50%;
  margin-left: -305.5px;
}

.its-left {
  position: absolute;
  left: 18.75%;
  top: 304px;
}

.its-main-title {
  color: #F9D55A;
  font-size: 43px;
}

.its-sub-title {
  margin-top: 37px;
  color: white;
  font-size: 30px;
  line-height: 1.5;
}

.its-video {
  position: absolute;
  right: 18.75%;
  top: 232px;
  width: 722px;
  height: 456px;
}

@media screen and (min-width: 1280px) and (max-width: 1560px) {
  .its-video {
    right: 16%;
    top: 252px;
    width: 522px;
    height: 356px;
  }

  .its-left {
    left: 16%;
    top: 304px;
  }
}

@media screen and (max-width: 1280px) {
  .its-video {
    right: 12%;
    top: 252px;
    width: 422px;
    height: 306px;
  }
  
  .its-left {
    left: 12%;
    top: 284px;
  }
}

.its-video >>> .ts-ali-player .ts-cover-btn {
  width: 70px !important;
  height: 70px !important;
  top: auto;
  bottom: 20px;
  left: 20px;
}
</style>
